export default "__VITE_ASSET__fcecdb96__"